import styled from 'styled-components'

export const Wrapper = styled.div`
  h1, h2, h3, h4 {
    font-family: 'Citrina', Helvetica, sans-serif;
  }
`
